import CustomerService from '../CustomerService';
import MockCustomerService from '../implementations/MockCustomerService';
import ODMCustomerService from '../implementations/ODMCustomerService';
import { CustomerServiceInterface } from '../interface/CustomerServiceInterface';

export enum CustomerServiceType {
  MOCK = 'MOCK',
  ODM = 'ODM',
}

export default class BasketServiceFactory {
  static createCustomerService(type: CustomerServiceType = CustomerServiceType.ODM): CustomerService {
    let service: CustomerServiceInterface;

    switch (type) {
      case CustomerServiceType.MOCK:
        service = new MockCustomerService();
        break;
      default:
        service = new ODMCustomerService();
    }

    return new CustomerService(service);
  }
}
